import { Component, Input, computed, inject } from '@angular/core'
import { NgbOffcanvas, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { CommonModule } from '@angular/common'
import { AppStore } from 'src/app/core/app.store'
import { StaffPulloutComponent } from '../staff-pullout/staff-pullout.component'
import { RouterModule } from '@angular/router'

@Component({
    selector: 'sf-staff-icon-horizontal-list',
    template: `
        <div class="d-flex flex-row align-items-center staff-list">
            @for (item of staff(); track item.id) {
                <a
                    class="staff-list__item"
                    [ngClass]="{ active: item.isOnline }"
                    placement="bottom"
                    [ngbTooltip]="item.fullName + ' | ' + item.id"
                    container="body"
                    routerLink="staff/{{ item.id }}">
                    <img [src]="item.picture" [alt]="item.fullName + ' | ' + item.id" class="img-fluid" />
                </a>
            }
            @if (showViewAllButton) {
                <div class="staff-list__view-more" (click)="viewAll()">view all</div>
            }
        </div>
    `,
    styleUrls: ['./staff-icon-horizontal-list.component.scss'],
    imports: [CommonModule, RouterModule, NgbTooltipModule]
})
export class StaffIconHorizontalListComponent {
    public appStore = inject(AppStore)
    public offcanvas = inject(NgbOffcanvas)

    @Input()
    countToShow = 5

    @Input()
    onlyShowOnlineUsers = false

    @Input()
    showViewAllButton = false

    staff = computed(() => {
        return this.appStore.staffWithOnlineStatus().splice(0, this.countToShow)
    })

    viewAll(): void {
        this.offcanvas.open(StaffPulloutComponent, { position: 'end' })
    }
}
